import React from "react";
import puzzlePattern from "../assets/puzzle.svg";

const AnimatedBackground: React.FC = () => {
  return (
    <>
      {/* Animated gradient background - further lightened for better contrast */}
      <div className="fixed inset-0 z-deepest-behind">
        <div className="absolute inset-0 animate-gradient bg-gradient-to-r from-purple-600 via-brand to-purple-500 bg-[length:200%_100%]" />
      </div>

      {/* Pattern overlay */}
      <div className="fixed inset-0 z-deep-behind opacity-[0.02]">
        <div
          className="absolute -inset-[25%] bg-repeat"
          style={{
            backgroundImage: `url(${puzzlePattern})`,
            backgroundSize: "150px 150px",
            transform: "rotate(-15deg)", // Just rotation, using negative inset instead of scale
          }}
        />
      </div>

      {/* Vignette effect */}
      <div className="fixed inset-0 z-behind bg-radial-vignette" />

      {/* Rising particles */}
      <div className="fixed inset-0 z-deep-behind overflow-hidden">
        {Array.from({ length: 20 }).map((_, i) => (
          <div
            key={i}
            className="absolute animate-rise"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 10}s`,
              animationDuration: `${15 + Math.random() * 10}s`,
              opacity: 0.1 + Math.random() * 0.2,
              width: `${2 + Math.random() * 4}px`,
              height: `${2 + Math.random() * 4}px`,
            }}
          />
        ))}
      </div>
    </>
  );
};

export default AnimatedBackground;
